import React, { useContext, useState, useEffect } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import ContractOwnershipList from 'src/models/ContractOwnershipList';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import AgreementUtil from 'src/util/AgreementUtil';
import useFetch from 'use-http';
import LeaseholdSearchResults from './ManageLeaseholdDialogComponents/LeaseholdSearchResults';

export interface IRatifyAddlOwnershipDialogProps {
    navigate: (path: string) => void;
    onCloseDialog?: () => void;
}

export type IRatifyAddlOwnershipDialogStateProps = {
    ownershipId: number;
    horizonNumber?: number;
    parentOwnershipId?: number;
};

type IRatifyAddlOwnershipDialogPageProps = IRatifyAddlOwnershipDialogProps & IRatifyAddlOwnershipDialogStateProps;

const RatifyAddlOwnershipDialog = (props: IRatifyAddlOwnershipDialogPageProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const { get } = useFetch();
    const [isLeaseholdSearchLoading, setIsLeaseholdSearchLoading] = useState(true);
    const [searchResults, setSearchResults] = useState<Array<ContractOwnershipList>>(undefined);
    const [isAgreementFound, setIsAgreementFound] = useState(undefined);

    const onNavigate = (contractId: number, contractholdId: number, contractType: string) => {
        let navPath = AgreementUtil.navToLeasehold(props.ownershipId, contractId, contractholdId, contractType);
        if (navPath.length > 0) {
            props.navigate(navPath);
            props.onCloseDialog();
        } else {
            window.alert('Invalid Agreement Type!');
            console.log('Invalid Agreement type for navigation: ', contractType);
        }
    };

    useEffect(() => {
        if (props.ownershipId > 0) {
            setSearchResults([]);
            setIsAgreementFound(undefined);
            handleRatifyList();
        }
    }, [props.ownershipId]);

    const handleRatifyList = async () => {
        const parentGet = get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/ownershipId/${props.parentOwnershipId}/active-contracts/true`);
        const attachedGet = get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leases/ownershipId/${props.ownershipId}/active-contracts/true`);

        const [parentResults, attachedResults] = await Promise.all([parentGet, attachedGet]);

        if (parentResults !== undefined && attachedResults !== undefined) {
            let attachedIds = attachedResults.map((ar: ContractOwnershipList) => ar.agreementNumber);
            let newResults: Array<ContractOwnershipList> = parentResults.filter((pr: ContractOwnershipList) => !attachedIds.includes(pr.agreementNumber));

            setIsAgreementFound(newResults?.length > 0);
            setSearchResults(newResults ?? []);
            setIsLeaseholdSearchLoading(false);
        }
    };

    return (
        <Dialog title="Ratify Additional Ownership">
            <div style={{ width: '60vw' }}>
                <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                    <legend className="legend">Search Existing Contract Ownerships</legend>
                </fieldset>

                <LeaseholdSearchResults
                    searchResults={searchResults}
                    isLeaseholdSearchLoading={isLeaseholdSearchLoading}
                    isAgreementFound={isAgreementFound}
                    onNavigate={onNavigate}
                />
            </div>
        </Dialog>
    );
};

export default RatifyAddlOwnershipDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/RatifyAddlOwnershipDialog.tsx